import React from 'react';
import ContractTypeForm from './ContractTypeForm';

function ContractTypeEdit() {
   return <ContractTypeForm mode="edit" />;
}

export default ContractTypeEdit;
